import { Reveal, MaskText, Stagger, StaggerItem } from "./Reveal";

const DAYS = [
  { n: "01", q: "Where are you now?", body: "Identify the developmental stage of your business or initiative.", out: "Founder Stage Assessment" },
  { n: "02", q: "Where are you going?", body: "Decide what you want to make true over the next 12 months.", out: "12-Month Vision" },
  { n: "03", q: "Who are you building it for?", body: "Clarify your customer and separate what you know from what you're still assuming.", out: "Customer + Validation Map" },
  { n: "04", q: "How does the business work?", body: "Look at the economics, operations and resources underneath the vision.", out: "Business Model + Numbers" },
  { n: "05", q: "How will you grow?", body: "Map how customers will discover you, trust you, buy, return and tell other people.", out: "Sales + Growth Plan" },
  { n: "06", q: "What could get in the way?", body: "Identify risks, constraints, unfinished fundamentals and major decisions before they become emergencies.", out: "Risk + Readiness Plan" },
  { n: "07", q: "What happens next?", body: "Turn everything you've learned into priorities, timing and action.", out: "Your 12-Month Business Roadmap", final: true },
];

export const SevenDays = () => (
  <section id="days" className="relative bg-cream py-24 sm:py-32">
    <div className="mx-auto max-w-[1300px] px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-y-8 gap-x-12 items-end">
        <div className="lg:col-span-7">
          <span className="font-sans text-xs uppercase tracking-[0.28em] text-cognac">The System</span>
          <h2 className="mt-6 font-serif text-ocean tracking-[-0.02em] leading-[0.96] text-4xl sm:text-6xl lg:text-[4.6rem]">
            <MaskText lines={["Seven days.", <span key="r" className="italic text-cognac">One clear roadmap.</span>]} />
          </h2>
        </div>
        <Reveal delay={0.1} className="lg:col-span-5">
          <p className="font-sans text-base sm:text-lg text-ink/72 leading-relaxed lg:border-l border-[var(--line)] lg:pl-6">
            This is not seven days of inspirational videos followed by a binder full of homework.
            Each day answers one important business question. By the end, those answers become your
            personalized 12-month roadmap.
          </p>
        </Reveal>
      </div>

      <Stagger className="mt-16 border-t border-[var(--line)]" amount={0.08}>
        {DAYS.map((d) => (
          <StaggerItem key={d.n}>
            <div
              data-testid={`day-${d.n}`}
              className={`group grid md:grid-cols-12 gap-x-8 gap-y-3 py-7 sm:py-9 border-b border-[var(--line)] transition-colors duration-500 hover:bg-sand/60 -mx-4 px-4 ${d.final ? "bg-ocean text-cream hover:bg-ocean" : ""}`}
            >
              <div className="md:col-span-2 flex items-baseline gap-3">
                <span className={`font-sans text-[11px] uppercase tracking-[0.24em] ${d.final ? "text-cognac" : "text-cognac"}`}>Day</span>
                <span className={`font-serif text-5xl sm:text-6xl leading-none ${d.final ? "text-cream" : "text-ocean/20 group-hover:text-cognac transition-colors duration-500"}`}>{d.n}</span>
              </div>
              <div className="md:col-span-6">
                <h3 className={`font-serif text-2xl sm:text-3xl tracking-tight ${d.final ? "text-cream" : "text-ocean"}`}>{d.q}</h3>
                <p className={`mt-2 font-sans text-base leading-relaxed max-w-lg ${d.final ? "text-cream/70" : "text-ink/68"}`}>{d.body}</p>
              </div>
              <div className="md:col-span-4 md:text-right md:pt-2">
                <div className={`font-sans text-[11px] uppercase tracking-[0.22em] ${d.final ? "text-cognac" : "text-ink/45"}`}>Output</div>
                <div className={`mt-1 font-serif italic text-lg sm:text-xl ${d.final ? "text-cream" : "text-ocean"}`}>{d.out}</div>
              </div>
            </div>
          </StaggerItem>
        ))}
      </Stagger>

      <Reveal delay={0.1}>
        <blockquote className="mt-20 sm:mt-24 text-center font-serif text-ocean tracking-[-0.02em] leading-[1.02] text-3xl sm:text-5xl lg:text-[3.8rem] max-w-4xl mx-auto">
          You don't leave with more information.
          <span className="block italic text-cognac mt-2">You leave knowing what to do.</span>
        </blockquote>
      </Reveal>
    </div>
  </section>
);
